// extracted by mini-css-extract-plugin
export var filterIncDec = "_bw-0";
export var leftBorder = "_bw-1";
export var rightBorder = "_bw-2";
export var stringInput = "_bw-3";